import { VxeInput } from 'vxe-pc-ui';
import { ref, unref, watch } from 'vue';
export default {
  name: 'XInput',
  components: {
    VxeInput
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'change'],
  setup(props, {
    emit
  }) {
    const formValue = ref(unref(props.value));
    watch(() => props.value, val => {
      console.log('input props changed1:', val);
      if (unref(val) !== formValue.value) {
        formValue.value = unref(val);
        console.log('input props changed2:', unref(val));
      }
    }, {
      immediate: true
    });
    const handleInputChanged = value => {
      if (value !== props.value) {
        emit('change', value);
        emit('update:value', value);
        console.log('value changed', value);
      }
    };
    return {
      handleInputChanged,
      formValue
    };
  }
};